import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { PropertyVerifiedType } from '../../../stats/types';

export class Snowplow2StatsAdapterVerified implements StatsAdapterInterface {
  /**
   *
   * @param verified
   */
  constructor(protected verified: PropertyVerifiedType) {}

  /**
   * @inheritDoc
   */
  public getData(): boolean {
    if (this.verified === 'Verified') {
      return true;
    }

    if (this.verified === 'Not verified') {
      return false;
    }

    throw TypeError('Unknown verified type');
  }
}
